import { CustomerFieldsLayoutHeader } from './CustomerFieldsLayoutHeader';
import { EmploymentFields } from './EmploymentFields';
import { CustomerFieldsContainer } from './HousingAndEmploymentInfo.style';

export const CurrentEmployment = () => {
    return (
        <CustomerFieldsContainer data-testid="current-employment-section">
            <CustomerFieldsLayoutHeader>Current Employment</CustomerFieldsLayoutHeader>
            <EmploymentFields employmentType="currentEmployment" />
        </CustomerFieldsContainer>
    );
};
